const initialState = {
  promoCodes: [],
  promoUsage: null,   // store usage analytics
  promoBanners: [],  // store promotional banners
};

export const promoCodeReducer = (state = initialState, action) => {
  switch (action.type) {

    case "SET_PROMOCODES":
      return {
        ...state,
        promoCodes: action.payload
      };

    case "ADD_PROMOCODE":
      return {
        ...state,
        promoCodes: [...state.promoCodes, action.payload]
      };

    case "UPDATE_PROMOCODE":
      return {
        ...state,
        promoCodes: state.promoCodes.map((p) =>
          p.id === action.payload.id ? action.payload : p
        )
      };

    case "TOGGLE_PROMOCODE":
      return {
        ...state,
        promoCodes: state.promoCodes.map((p) =>
          p.id === action.payload.id ? action.payload : p
        )
      };

    case "USED_PROMOCODE":
      return {
        ...state,
        promoUsage: action.payload
      };
    
      case "GET_PROMO_BANNERS":
        return{
          ...state,
          promoBanners: action.payload
        };

    default:
      return state;
  }
};